import React, { lazy } from 'react';
import { withRouter } from 'react-router-dom';
// import Home from './components';
import PrivateRoute from 'PrivateRoutes';
const Home = lazy(()=> import(/* webpackChunkName: "home" */ './components'))

const routes = () => [
  <PrivateRoute key='home' exact path='/' component={Home} />,
];

export default withRouter(routes);



// WEBPACK FOOTER //
// src/modules/screens/home/routes.js